module.exports = __webpack_public_path__ + "static/img/first-page-disabled.f5a2f46f.svg";